import * as Types from "../../actions/constants/types";

const initialState = {
  loginData: {
    loading: false,
    error: false,
    success: false,
    msg: null,
  },
};

export default (state = initialState, action) => {
  //console.log(action.error);
  switch (action.type) {
    case Types.LOGIN:
      return {
        ...state,
        loginData: {
          loading: true,
          error: false,
          success: false,
          msg: null,
        },
      };
    case Types.LOGIN_SUCCESS:
      return {
        ...state,
        loginData: {
          loading: false,
          error: false,
          success: true,
          msg: action.response,
        },
      };
    case Types.LOGIN_ERROR:
      return {
        ...state,
        loginData: {
          loading: false,
          error: true,
          success: false,
          msg:
            typeof action.error !== "undefined" &&
            typeof action.error.data !== "undefined" &&
            typeof action.error.data.error !== "undefined" &&
            typeof action.error.data.error.message != "undefined"
              ? action.error.data.error.message
              : "",
        },
      };
    case Types.RESET_ALERT:
      return {
        ...state,
        loginData: {
          loading: false,
          error: false,
          success: false,
          msg: null,
        },
      };
    default:
      return state;
  }
};
